import styled from 'styled-components';
import bg from '../../../images/bg.png';
import {Button} from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

export const Container = styled.div`
  &.SearchPortalWrapper{
    background: url(${bg});
    min-height: 100vh;
    background-position: top left;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
  &.MainWrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  & .footerLink{
    margin-bottom: 15px;
  }
  @media screen and (min-width: 576px) {
    & .footerLink{
      margin-right: 30px;
      margin-bottom: 0;
    }
  }
`;

export const SearchContainer = styled.div`
  max-width: 960px;
  width: 100%;
  margin-bottom: 90px;
  margin-top: 40px;
`

export const Footer = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 30px 50px;
  height: 50px;
  margin-bottom: 20px;
`

export const StyledParagraph = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 168%;
  text-align: center;
  color: #A6AAB1;
  margin-bottom: 0;
`;

export const LinksContainer = styled.div`
  & a{
    margin-right: 50px;
  }
`

export const LogoName = styled.h1`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  line-height: 50px;
  text-align: center;
  color: #1C62EF;;
`;

export const StyledModalBtn = styled(Button)`
  margin: 30px 0 !important;
  width: 162px;
  height: 50px;
  background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%) !important;
  border-radius: 8px !important;
  border-width: 0 !important;
`
export const ModalBody = styled(Modal.Body)`
  padding: 64px 33px 0 33px ;
  margin-bottom: 40px;
  text-align: center;
`;
export const InviteParagraph = styled.p`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 154%;
  text-align: center;
  color: #4F5388;
  margin-bottom: 43px;
  & p{
    margin-top: 20px;
  }
`;